(function(module) {
    'use strict';

    function PlaylistsCtrl(utils, $state, Playlist, Store, $mdDialog, App, Includes, AppStylesInPlaylist, Display, Group) {

        this.getApps = () => {
            return App
                .find({ filter: Includes.apps })
                .$promise
                .then((response) => {
                    this.loading = false;
                    this.apps = Store.setMultiModelData('apps', response);
                    return response;

                });
        };

        this.setDefault = () => {
            this.playlists = null;
            this.apps = null;
            this.appsWithStyles = null;

            this.loading = true;
            this.selectedCount = 0;
        };

        this.getData = () => {
            return Playlist
                .find()
                .$promise
                .then((response) => {
                    this.loading = false;
                    this.playlists = Store.setMultiModelData('playlists', response);
                })
                .then(() => {
                    return this.getApps();
                })
                .then((apps) => {
                    // get styles and name for the app in the playlist
                    this.playlists.forEach((playlist) => {
                        this.appsWithStylesInPlaylist = AppStylesInPlaylist.getAppStylesInPlaylist(playlist.apps, apps);
                        playlist.appsWithStyles = [];
                        playlist.appsWithStyles = this.appsWithStylesInPlaylist;

                    });
                });
        };

        this.$onInit = () => {
            this.utils = utils;

            this.selectAllCheckbox = false;
            this.orderBy = 'name';

            this.setDefault();
            this.getData();
        };

        this.onSubAccountChange = () => {
            this.$onDestroy();
            this.setDefault();
            this.getData();
        };

        this.$onDestroy = () => {

        };

        this.selectAll = () => {
            this.filteredItems.forEach((playlist) => {
                playlist.selected = this.selectAllCheckbox;
            });
            this.updateSelectedCount();
        };

        this.updateSelectedCount = () => {
            this.selectedCount = _.chain(this.playlists).filter((playlist) => playlist.selected).size().value();
        };

        this.select = () => {
            this.updateSelectedCount();
        };

        this.findDisplaysUsingPlaylistId = (playlistIds) => {
            return Display
                .find({
                    filter: {
                        where: { playlistId: { inq: playlistIds } },
                        fields: ['id'],
                    },
                })
                .$promise;
        };

        this.findGroupsUsingPlaylistId = (playlistIds) => {
            return Group
                .find({
                    filter: {
                        where: { playlistId: { inq: playlistIds } },
                        fields: ['id'],
                    },
                })
                .$promise;
        };

        this.openDialog = (modalTitle, modalConfirmationText, modalCancelText, modalConfirmText, confirmActionFunc, itemCount1, itemCount2, ids) => {
            $mdDialog.show({
                locals: {
                    title: modalTitle,
                    confirmationText: modalConfirmationText,
                    cancelText: modalCancelText,
                    confirmText: modalConfirmText,
                    itemCount1: itemCount1,
                    itemCount2: itemCount2,

                },
                controller: ($scope, $mdDialog) => {
                    $scope.cancel = () => {
                        $mdDialog.hide();
                    };
                    $scope.confirm = () => {
                        $scope.cancel();

                        confirmActionFunc(ids);
                    };
                },
                controllerAs: '$ctrl',
                bindToController: true,
                templateUrl: '/js/components/warning-dialog/warning-dialog.html',
                parent: angular.element('body'),
                clickOutsideToClose: true,
                escapeToClose: true,
            });
        };

        this.delete = () => {
            const ids = _.chain(this.playlists)
                .filter({ selected: true })
                .map((item) => item.id)
                .value();

            Promise.all([
                this.findDisplaysUsingPlaylistId(ids),
                this.findGroupsUsingPlaylistId(ids),
            ])
                .then(([displaysUsingPlaylist, groupsUsingPlaylist]) => {
                    let displaysUsingPlaylistCount = displaysUsingPlaylist && displaysUsingPlaylist.length;
                    let groupsUsingPlaylistCount = groupsUsingPlaylist && groupsUsingPlaylist.length;
                    let modalTitle;
                    let modalConfirmationText;
                    let modalCancelText;
                    let modalConfirmText;
                    let confirmActionFunc;
                    let itemCount1;
                    let itemCount2;

                    //playlist not being used by both displays and groups : remove playlist

                    if (displaysUsingPlaylistCount <= 0 && groupsUsingPlaylistCount <= 0) {
                        modalTitle = 'Are you sure you want to permanently remove selected playlists?';
                        modalConfirmText = 'Yes, remove';
                        modalCancelText = 'Cancel';
                        confirmActionFunc = (ids) => {
                            return Playlist.destroyAll({
                                where: { id: { inq: ids } },
                            })
                                .$promise
                                .then(() => {
                                    _.remove(this.playlists, (playlist) => _.indexOf(ids, playlist.id) >= 0);
                                    this.selectAllCheckbox = false;
                                    if (this.playlists.length === 0) {
                                        this.selectedCount = 0;
                                    }
                                })
                                .catch((error) => {
                                    console.error('error', error);
                                });
                        };
                        //display is using playlist but the group isnt
                    } else {
                        modalTitle = 'You can\'t delete selected playlist/s as being used by :';

                        itemCount1 = displaysUsingPlaylistCount > 0 ? `${displaysUsingPlaylistCount + ' of your displays'}` : null;
                        itemCount2 = groupsUsingPlaylistCount > 0 ? `${groupsUsingPlaylistCount + ' of your groups'}` : null;

                        modalConfirmationText = 'Please make sure the playlists are not being used before deleting.';
                        modalCancelText = 'Ok, I understand';
                    }

                    this.openDialog(modalTitle, modalConfirmationText, modalCancelText, modalConfirmText, confirmActionFunc, itemCount1, itemCount2, ids);

                });
        };
    }

    module
        .config(($stateProvider, $translatePartialLoaderProvider, envServiceProvider) => {

            const FEATURES = envServiceProvider.read('features');
            const PLAYLISTS = _.get(FEATURES, 'playlists', false);

            $stateProvider.state('root.playlists', {
                url: '/playlists',
                data: {
                    pageTitle: 'PLAYLISTS.PAGE_TITLE',
                },
                views: {
                    'content@root': {
                        template: '<playlists-component />',
                    },
                },

                bodyClass: 'page--playlists',
                resolve: {
                    show: function($state) {
                        if (FEATURES && !PLAYLISTS) {
                            return $state.go('root');
                        }
                    },
                },
            });

            // Translations
            $translatePartialLoaderProvider.addPart('/js/playlists');

        })
        .component('playlistsComponent', {
            templateUrl: '/js/playlists/playlists.html',
            controller: PlaylistsCtrl,
        });

})(angular.module('rocket.components'));
